import {createAction} from 'redux-actions';

const pending = createAction('fetch-pending');
const rejected = createAction('fetch-rejected');
const fulfilled = createAction('fetch-fulfilled');
const cancelled = createAction('fetch-cancelled');
const init = createAction('init-params');
const filterChanged = createAction('filter-changed');
const pageChanged = createAction('page-changed');
const sort = createAction('sort');
const viewTypeChange = createAction('view-type-changed');

export const actions = {
    viewTypeChange,filterChanged, pending, rejected, fulfilled, cancelled, pageChanged, sort,init
};
